<template>
  <div class="outer-wrapper">
    <div class="button-wrapper">
      <Button
        class="print-button"
        slot="extra"
        v-print="printParams"
        key="to_single_print"
        >打印</Button
      >
    </div>
    <div id="to_single_print">
    <div class="content" >
      <div class="inner">
        <p class="table-no">表号：{{ value.formNo }}</p>
        <p class="comnamech">上海赛恩工贸有限公司</p>
        <p class="comnameen">Shanghai Saien Industrial & Trading Co., Ltd.</p>
        <p class="title">硬度检测报告</p>
        <p class="sn" @click="alterInputClick('reportNo','报告编号')">
          编号：<span>{{ value.reportNo }}</span>
        </p>
        <table class="p1">
          <tr>
            <td rowspan="4" width="6%" style="padding:0 5pt;"><p>检件信息
              </p></td>
            <td width="16%"><p>产品编号</p></td>
            <td colspan="3">
              <p>{{ value.pronum }}</p>
            </td>
          </tr>
          <tr>
            <td><p @click="alterInputClick('productName','产品名称')">产品名称</p></td>
            <td width="30%" @click="alterInputClick('productName','产品名称')">
              <p>{{ value.productName }}</p>
            </td>
            <td width="16%"><p @click="alterInputClick('volume','规格(L)')">规格(L)</p></td>
            <td width="32%" @click="alterInputClick('volume','规格(L)')">
              <p>{{ value.volume }}</p>
            </td>
          </tr>
          <tr>
            <td><p @click="alterInputClick('grade','材质')">材质</p></td>
            <td @click="alterInputClick('grade','材质')">
              <p>{{ value.grade }}</p>
            </td>
            <td><p @click="alterInputClick('heatType','热处理状态')">热处理状态</p></td>
            <td @click="alterInputClick('heatType','热处理状态')">
              <p>{{ value.heatType }}</p>
            </td>
          </tr>
          <tr>
            <td><p @click="alterInputClick('testPosition','检测部位')">检测部位</p></td>
            <td @click="alterInputClick('testPosition','检测部位')">
              <p>{{ value.testPosition }}</p>
            </td>
            <td><p @click="alterInputClick('thickness','公称厚度(mm)')">公称厚度(mm)</p></td>
            <td @click="alterInputClick('thickness','公称厚度(mm)')">
              <p>{{ value.thickness }}</p>
            </td>
          </tr>
          <tr>
            <td rowspan="3" style="padding:0 5pt;"><p>仪器型号</p></td>
            <td><p @click="alterInputClick('equipmentModel','仪器型号')">仪器型号</p></td>
            <td @click="alterInputClick('equipmentModel','仪器型号')">
              <p>{{ value.equipmentModel }}</p>
            </td>
            <td><p @click="alterInputClick('equipmentNo','仪器编号')">仪器编号</p></td>
            <td @click="alterInputClick('equipmentNo','仪器编号')">
              <p>{{ value.equipmentNo }}</p>
            </td>
          </tr>
          <tr>
            <td><p @click="alterInputClick('standard','检测标准')">检测标准</p></td>
            <td colspan="3" @click="alterInputClick('standard','检测标准')">
              <p>{{value.standard}}</p>
            </td>
          </tr>
          <tr>
            <td><p @click="alterInputClick('recordNo','原始记录编号')">原始记录编号</p></td>
            <td @click="alterInputClick('recordNo','原始记录编号')">
              <p>{{value.recordNo}}</p>
            </td>
            
            <td><p @click="alterInputClick('techNo','工艺规程编号')">工艺规程编号</p></td>
            <td @click="alterInputClick('techNo','工艺规程编号')">
              <p>{{ value.techNo }}</p>
            </td>
          </tr>
        </table>
        <table class="p2">
          <tr>
            <td width="6%" style="padding:0 5pt;"><p>检测部位示意图</p></td>
            <td width="94%">
              <div class="img-wrapper">
                <img :src="img1[value.lengthType]" alt="" style="height:110pt;"/>
              </div>
            </td>
          </tr>
        </table>
        <table class="p3">
          <tr>
            <td rowspan="3" width="6%" style="padding:0 5pt;"><p>检测结果
              </p></td>
            <td width="45%"><p>各截面布氏硬度（HB）平均值范围要求</p></td>
            <td width="55%">
              <p>{{ value.averageRequirement }}</p>
            </td>
          </tr>
          <tr>
            <td ><p>实测各截面布氏硬度（HB）平均值范围</p></td>
            <td>
              <p>{{ value.averageRange }}</p>
            </td>
          </tr>
          <tr>
            <td colspan="2">
              <div class="conclusion">
                <p>测定结论：</p>
                <p style="text-indent:24pt;">经测定上述壳体各截面布氏硬度（HB）平均值符合GB/T 20663-2017《蓄能压力容器》和相关技术要求，测定结论为
                  <span style="font-weight:600;text-decoration:underline;">合格</span>
                  。</p>
              </div>
            </td>
          </tr>
        </table>
        <table class="p4">
          <tr>
            <td width="30%"><p><span @click="alterSelectClick('sign1','检测签名')" class="sign-title">检测：<span class="sign-img" v-show="value.sign2"><img :src="urlTrans(value.sign1)" alt="" style="width:90pt;height:34pt;"></span></span></p></td>
            <td width="30%"><p><span @click="alterSelectClick('sign2','审核签名')" class="sign-title">审核：<span class="sign-img1" v-show="value.sign3"><img :src="urlTrans(value.sign2)" alt="" style="width:90pt;height:34pt;"></span></span></p></td>
            <td width="40%">
              <p><img :src="img3" alt="" style="height:20pt;"/></p>
              <p style="color:#ccc;">检验专用章盖章处</p>
              <p><span class="date" @click="alterInputClick('reportDate','报告日期','date')"> 日期：{{value.reportDate}}</span></p></td>
          </tr>
        </table>
      </div>
    </div>
    </div>

    <Modal v-model="modalValue.alterValue" :width="1000" :mask-closable="false">
      <i
        class="ivu-icon ivu-icon-ios-close"
        slot="close"
        @click="closeModal('alterValue')"
      ></i>
      <p slot="header" class="sc-header">
        <Icon type="ios-list-box" />
        <span>报告内容修改（{{ value.reportNo }}）</span>
      </p>
      <div class="sc-content-wrapper">
        <div class="inner-content-wrapper">
          <table class="base">
            <tr>
              <td>
                <span> {{ currentText }}： </span>
              </td>
              <td style="text-align: left">
                <input
                  autofocus
                  :type="currentType"
                  placeholder=""
                  v-model="currentValue"
                  style="width: 600px"
                  @keyup.enter="alterSubmit"
                />
              </td>
            </tr>
          </table>
        </div>
      </div>
      <div slot="footer">
        <Button size="large" @click="alterSubmit">确定</Button>
        <Button size="large" @click="closeModal('alterValue')">取消</Button>
      </div>
    </Modal>
    <Modal
      v-model="modalValue.alterValueSelect"
      :width="1000"
      :mask-closable="false"
    >
      <i
        class="ivu-icon ivu-icon-ios-close"
        slot="close"
        @click="closeModal('alterValueSelect')"
      ></i>
      <p slot="header" class="sc-header">
        <Icon type="ios-list-box" />
        <span>报告内容修改（{{ value.reportNo }}）</span>
      </p>
      <div class="sc-content-wrapper">
        <div class="inner-content-wrapper">
          <table class="base">
            <tr>
              <td>
                <span> {{ currentText }}： </span>
              </td>
              <td style="text-align: left">
                <select v-model="currentValue">
                  <option
                    :value="item.url"
                    v-for="(item, index) in signatureList"
                    :key="index"
                  >
                    {{ item.name }}
                  </option>
                </select>
              </td>
            </tr>
          </table>
        </div>
      </div>
      <div slot="footer">
        <Button size="large" @click="alterSubmit">确定</Button>
        <Button size="large" @click="closeModal('alterValueSelect')"
          >取消</Button
        >
      </div>
    </Modal>
  </div>
</template>
<script>
let authData = JSON.parse(localStorage.getItem("authData"));
let userToken = localStorage.getItem("current_user_token");

export default {
  name: "heatReport",
  props: {
    fileId: {
      type: String,
    },
  },
  components: {},
  created() {
    this.getContent();
    this.getStaticOptionsData();
  },
  data() {
    return {
      value: {},
      pronumList:[],
      printParams: {
        id: "to_single_print",
        popTitle: "",
      },
      fid: 0,
      modalValue: {
        alterValue: false,
        alterValueSelect: false,
      },
      currentValue: "",
      currentKey: "",
      currentText: "",
      currentType: "text",
      signatureList: [],
      img1: {'long':process.env.BASE_URL + "img/hard1.jpg",'short':process.env.BASE_URL + "img/hard2.jpg"},
      img3: process.env.BASE_URL + "img/stamp1.jpg",
    };
  },
  methods: {
    getStaticOptionsData() {
      this.$axios
        .post(this.$url + "/ask_static_options", {
          userToken: userToken,
          ask_data: "signatureList",
        })
        .then((response) => {
          if (response.data.stat === "ok") {
            this.signatureList = response.data.res_record.signatureList;
          } else {
            this.$Message.warning("请求选项数据失败！");
          }
        })
        .catch((error) => {
          this.$Message.warning(error + "网络错误！操作失败。");
        });
    },
    getContent() {
      this.$axios
        .post(this.$url + "/content", {
          userToken: userToken,
          askData: "normalReport",
          enid: this.fileId,
        })
        .then((response) => {
          if (response.data.stat == "ok") {
            this.fid = response.data.fid;
            this.value = response.data.content;
            this.$forceUpdate();
          } else {
            this.$Message.warning("未查到相关信息！");
          }
        });
    },
    alterInputClick(key, text, t = "text") {
      this.currentKey = key;
      this.currentText = text;
      this.currentValue = this.value[key];
      this.currentType = t;
      this.openModal("alterValue");
    },
    alterSelectClick(key, text) {
      this.currentKey = key;
      this.currentText = text;
      this.currentValue = this.value[key];
      this.openModal("alterValueSelect");
    },
    alterSubmit() {
      this.$axios
        .post(this.$url + "/content", {
          userToken: userToken,
          askData: "alterSingle",
          fid: this.fid,
          currentValue: this.currentValue,
          currentKey: this.currentKey,
        })
        .then((response) => {
          if (response.data.stat == "ok") {
            this.closeModal("alterValue");
            this.closeModal("alterValueSelect");
            this.getContent();
          } else {
            this.$Message.warning("数据更新失败！");
          }
        });
    },
    openModal(label) {
      this.modalValue[label] = true;
    },
    closeModal(label) {
      this.modalValue[label] = false;
    },
    urlTrans(url) {
      return this.$fileUrlFac(url, authData.sfileRight);
    },
  },
  computed: {},
};
</script>
<style scoped>
.outer-wrapper {
  margin: 0 auto;
  width: fit-content;
  text-align: center;
  padding: 10px 0 50px;
}

.button-wrapper {
  padding: 20px;
}
.content {
  height: 840.36pt;
  width: 594.3pt;
  color: #000;
  text-align: center;
  position: relative;
  margin: 1px;
  overflow: hidden;
}

@media screen {
  .divide-line {
    border-top: 1px solid #aaa;
  }
  .content {
    outline: #aaa solid 1px;
    margin-bottom: 10px;
    box-shadow: 1px 2px 1px #aaa;
  }
}

.inner {
  padding: 50pt;
}

.content .table-title {
  font-size: 14pt;
}

p {
  font-family: "Times New Roman", "宋体";
  font-size: 10pt;
  line-height: 24pt;
}

.content .table-no {
  position: absolute;
  top: 35pt;
  right: 50pt;
  font-size: 7pt;
  color: #999;
}

.content .comnamech {
  text-align: center;
  font-size: 16pt;
  font-weight: 600;
  letter-spacing: 8pt;
  margin-top: 8pt;
}

.content .comnameen {
  text-align: center;
  font-size: 12pt;
  font-weight: 600;
}

.content .title {
  text-align: center;
  font-size: 22pt;
  margin-top: 6pt;
  font-weight: 600;
  letter-spacing: 0pt;
}

.content .sn {
  text-align: right;
  font-size: 10pt;
  margin-top: 5pt;
}

table {
  border-collapse: collapse;
  width: 100%;
}
table td {
  border: 1px solid #333;
  text-align: center;
  padding: 3pt 5pt;
}

.cell-p {
  line-height: 14pt !important;
}

.free-text {
  text-align: left;
  padding: 3pt 10pt;
}

.underline {
  display: inline-block;
  width: 80pt;
  border-bottom: 1px solid #333;
  line-height: 14pt;
  text-align: center;
}

.w1 {
  border: 1px solid #333;
  padding: 10pt;
}

.sub-title {
  margin-top: 30pt;
  text-align: center;
  font-size: 16pt !important;
  font-weight: 600;
  margin-bottom: 10pt;
}

.sign {
  margin-top: 10pt;
  text-align: right;
}

.p1,
.p2,
.p3,
.w1,
.p4,
.p5 {
  border: 1px solid #333;
}

.p1 td,.p2 td,.p3 td  {
  padding: 9pt 0;
}

.p1 p,.p2 p,.p3 p {
  line-height: 1.2;
}

.p2 td{
  height:140pt;
}

.p3 td{
  padding: 9pt;
}

.s-line {
  position: relative;
  bottom: 0.5pt;
}

.sign-span {
  margin-right: 100pt;
  position: relative;
}

.sign-img {
  position: absolute;
  left:35pt;
  top:-8pt;
  z-index: 10;
}

.sign-img1 {
  position: absolute;
  left:85pt;
  top:-8pt;
  z-index: 10;
}

.sign-item {
  position: absolute;
  left: 50pt;
  white-space: nowrap;
}



.inner-content-wrapper {
  margin: 0 auto;
  width: fit-content;
}

table.base td {
  border: none;
}

input {
  border: none;
  outline: none;
  border-bottom: 1px solid #666;
  text-align: center;
  padding: 3pt 5pt;
}



.sign-title {
  text-align: left;
  position: relative;
  top:-20pt;
  left:-50pt;
}

.sign-mark {
  text-align: right;
}

.result {
  text-align: left;
  text-indent: 24pt;
}

table.p5 td {
  padding: 0pt 0;
  height:24pt;
}

.page {
  text-align: right;
  color: #999;
  padding-top: 5pt;
  padding-right: 5pt;
}

.float-temp1-1{
  top:63pt;
  left:333pt;
}

.float-temp1-2{
  top:90pt;
  left:333pt;
}

.ft{
  position: absolute;
  font-size: 13pt !important;
}

.stamp{
  margin-top:20pt;
  text-align: right;
  padding-right:100pt;
}

.date{
  text-align: right;
}
.img-wrapper{
  position: relative;
}

.p4 p{
  font-size: 11pt;
}

.img-title{
  text-align: left;
  line-height: 2;
}

.conclusion p{
  text-align: left;
  line-height: 2;
  font-size: 11pt;
}

</style>